import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在-黑料网曝大瓜',
    description: '你访问的页面不存在，返回黑料网曝大瓜首页继续浏览最新明星八卦与娱乐爆料。',
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 w-full max-w-[1280px] mx-auto px-4 md:px-8 flex flex-col items-center justify-center text-center py-24">
        <span className="font-heading font-black text-7xl md:text-9xl text-primary-100 select-none">404</span>
        <h1 className="mt-4 font-heading font-bold text-2xl text-foreground-950">这个瓜好像被删了</h1>
        <p className="mt-2 text-sm text-foreground-500">你访问的页面不存在：{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            返回首页
          </Link>
          <Link to="/search" className="px-5 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            搜索大瓜
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}